import http from '@/services/http';

export const showGeraisLiberacaoRequest = (empresa_id, competencia) => {
  return http.get(`/gerais/${empresa_id}`, {
    params: {competencia}
  })
}

export const uploadGeraisRequest = (payload) => {
  return http.post('/gerais/upload', payload)
};

export const geraisCreateRequest = (payload) => {
  return http.post(`/gerais`, payload);
};
export const geraisUpdateRequest = (payload) => {
  return http.put(`/gerais/`+payload.id, payload);
};
export const geraisDeleteRequest = (payload) => {
  return http.put(`/gerais/delete/`+payload.gerais_id, payload);
};

export const geraisRequest = (params) => {
  return http.get(`/gerais`,{params:params});
};

export const geraisNotaFiscalRequest = (payload) => {
  return http.post(`/gerais/notafiscal/` +payload.id ,payload);
};

export const geraisNaoProcessadasRequest = () => {
  return http.get('/gerais/nao-processadas');
};

export const chageLiberacaoRequest = (payload) => {
  return http.post('/gerais/change-liberacao', payload);
};

export const deleteGeraisNaoProcessadaRequest = (id) => {
  return http.delete('/gerais/nao-processadas/' + id);
};

export const tiposGeraisRequest = () => {
  return http.get('/gerais/tipos');
};

export const createGeraisRequest = (payload) => {
  return http.post('/gerais/store', payload);
};

export const estornarGeraisRequest = (id) => {
  return http.put('/gerais/estorno/' + id);
};

export const sendGeraisRequest = (payload) => {
  return http.post('/gerais/send', payload);
};

export const liberaGeraisRequest = (data_competencia) => {
  return http.patch('gerais/libera-envios', {data_competencia})
}


export const getRequiredGuidesByCompanyId = (empresa_id) => {
  return http.get(`/empresas/${empresa_id}/required-guides`)
}

export const saveRequiredGuidesByCompanyId = (empresa_id, payload) => {
  return http.post(`/empresas/${empresa_id}/required-guides`, payload)
}

export const getRequiredGuidesList = () => {
  return http.get(`/required/guides`)
}

export const changeTributacaoFrequency = (empresa_id, payload) => {
  return http.post(`empresas/${empresa_id}/tributacao-frequency`, payload)
}

export const getTributacaoFrequency = (empresa_id) => {
  return http.get(`empresas/${empresa_id}/tributacao-frequency`)
}

export const getUploadReport = () => {
  return http.get(`gerais/upload-report`)
}
